import {Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf} from '@angular/core';
import {FORM_GROUP_CONTEXT} from "../form-group-context.tokens";
import {FormGroupExtension} from "../extensions/form-group-extension/form-group.extension";
import {ControlContainer, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'form-group-files',
  templateUrl: './form-group-files.component.html',
  providers: [
    {
      provide: FORM_GROUP_CONTEXT,
      useExisting: FormGroupFilesComponent
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormGroupFilesComponent),
      multi: true,
    },
  ]
})
export class FormGroupFilesComponent extends FormGroupExtension implements OnInit {

  constructor(@Optional() @Host() @SkipSelf() protected controlContainer: ControlContainer) {
    super(controlContainer);
  }

  config: any;
  single: any;
  @Input('config') set config$(value) {
    if (value) {
      this.config = value;
    }
  };
  @Input('single') set single$(value) {
    if (value !== undefined) {
      this.single = value;
    }
  };
  @Input() accepted;

  ngOnInit() {
    this.registerControl();
  }
}
